
import ProductInfoCard from "./productInfoCard";
import BottomCart from "./bottom-cart";
import { useLocation, useNavigate } from "react-router-dom";
import { useContext } from "react";
import { cartContext } from "../App";
import HeaderOther from "./header-other";
import './display-product.css';

export default function DisplayProducts() {
    
    const { productDataList, maxAmountReached } = useContext(cartContext);
    const location = useLocation();
    const { category, name, productList } = location.state || [];

    const cat = category.split(',');

    const data = productList ? productList : (productDataList.filter((item) => 
            cat.some((c) => c === item.data.category)
        ))

    return (
        <>
            {
                maxAmountReached && (
                    <div className="max-amount-reached">
                        <p className="max-amount-reached-text">Maximum Quantity Reached!</p>
                    </div>
                )
            }
            <HeaderOther />
            <p className="category-headings">{ name }</p>
            <div className="container" style={{marginTop:'10px'}}>
                <ProductInfoCard dataList={data} />
            </div>
            <BottomCart />
        </>    
    );
}
